import { ViewModel, View, ObservableArray } from "binder"
import { ProductionRestartEditorView } from "./productionRestartEditor-view"
import { IProductionRestart } from "../IProductionRestart";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { TimeSelectorViewModel } from "uicomponents";

export class ProductionRestartEditorViewModel extends ViewModel implements IProductionRestart, IPopup {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionRestartEditorView();
    }
    public getTypeId(): string {
        return "VM-A8EE5A7F-1911-44DB-AB6F-0F0176D0C485"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from; } private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until; } private _until: moment.Moment;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set stopReasonName(v: string) { this._stopReasonName = v; } public get stopReasonName(): string { return this._stopReasonName; } private _stopReasonName: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set type(v: string) { this._type = v; } public get type(): string { return this._type; } private _type: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set isOpen(v: boolean) { this._isOpen = v; } public get isOpen(): boolean { return this._isOpen; } private _isOpen: boolean;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;

    closePopup(result?: any) {

    }

    async cloneTo(productionRestart: IProductionRestart) {
        productionRestart.id = this.id;
        productionRestart.date = this.date;
        productionRestart.from = this.from;
        productionRestart.until = this.until;
        productionRestart.productLineName = this.productLineName;
        productionRestart.workStationName = this.workStationName;
        productionRestart.stopReasonName = this.stopReasonName;
        productionRestart.personnelName = this.personnelName;
        productionRestart.type = this.type;
        productionRestart.description = this.description;
        productionRestart.isOpen = this.isOpen;
        
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت رفع توقفات');
                return;
            } else {
                this.isLoading = true;
                let time = this.timeSelector.selectedHour.no * 60 + this.timeSelector.selectedMinute.no;
                let result = await ServerConnection.callServer("/Complex/ProductionStopServices/RestartProductionStop", {
                    ProductionStopId: this.id,
                    Description: this.description,
                    Until: this.date.add(time, "m")
                })
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess('رفع توقفات با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در ثبت رفع توقفات', 'خطا در عملیات');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (this.date == null) {
            result.push('تاریخ مشخص نشده است.');
        }
        return result;
    }
}
